import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CartContainer from '../cart_container/CartContainer';
import './CartWrapper.sass';

class CartWrapper extends Component {
  cartContainerRef = React.createRef();

  componentDidMount() {
    window.addEventListener('click', this.onWindowClickHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClickHandler);
  }

  // close cart if user clicked outside
  onWindowClickHandler = (event) => {
    const {
      closeCart, cartActive, bucketRef,
    } = this.props;

    if (cartActive
        && !bucketRef.current.contains(event.target)
        && !this.cartContainerRef.current.contains(event.target)
        && typeof document !== 'undefined'
        && !event.target.id.includes('qp-modal')
        && !document.querySelector('.mobile-menu')?.contains(event.target)) {
      closeCart();
    }
  };

  render() {
    const {
      cartActive, lineItems, lineItemsCount, guestToken,
      orderNumber, closeCart, orderTotal, freeSamplesTitle,
      applyCouponCodeRequest, couponCodeErrorText, couponCodeSuccessText, orderLoading,
      defaultLineItemsCount,
    } = this.props;

    return (
      <div className={classNames('cart-wrapper', { show: !defaultLineItemsCount && cartActive })}>
        <div className="overlay" />
        <CartContainer
          applyCouponCodeRequest={applyCouponCodeRequest}
          closeCart={closeCart}
          couponCodeErrorText={couponCodeErrorText}
          couponCodeSuccessText={couponCodeSuccessText}
          guestToken={guestToken}
          lineItems={lineItems}
          lineItemsCount={lineItemsCount}
          orderLoading={orderLoading}
          orderNumber={orderNumber}
          orderTotal={orderTotal}
          freeSamplesTitle={freeSamplesTitle}
          ref={this.cartContainerRef}
        />
      </div>
    );
  }
}

CartWrapper.propTypes = {
  applyCouponCodeRequest: PropTypes.func.isRequired,
  bucketRef: PropTypes.shape({
    current: PropTypes.shape({
      contains: PropTypes.func,
    }),
  }).isRequired,
  cartActive: PropTypes.bool.isRequired,
  closeCart: PropTypes.func.isRequired,
  couponCodeErrorText: PropTypes.string,
  couponCodeSuccessText: PropTypes.string,
  guestToken: PropTypes.string,
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  lineItemsCount: PropTypes.number.isRequired,
  orderLoading: PropTypes.bool,
  orderNumber: PropTypes.string,
  orderTotal: PropTypes.number.isRequired,
  defaultLineItemsCount: PropTypes.number,
  freeSamplesTitle: PropTypes.string.isRequired,
};

export default CartWrapper;
